module.exports = new __parcel__URL__("MMIRL7.adfcf166.jpg").toString();